import React from "react"
import PropTypes from "prop-types"
import Link from "components/Link"
import theme from "styles/theme"

const BlockHeader = ({ label, title, titleUrl, className }) => (
  <div
    css={{
      maxWidth: 746,
      margin: "0 auto",
      textAlign: "center",
      [theme.tablet]: { maxWidth: 620 },
      "--labelColor": theme.midBlue,
      "--titleColor": theme.textGray,
    }}
    className={className}
  >
    {label && (
      <div
        css={theme.expandQueries({
          ...theme.t5lg,
          color: "var(--labelColor)",
          marginBottom: [16, 13, 11],
        })}
      >
        {label}
      </div>
    )}

    <h2
      css={{
        ...theme.t3,
        color: "var(--titleColor)",
        marginBottom: 0,
      }}
    >
      {typeof titleUrl === "string" && titleUrl.trim()
        ? <Link
            css={{
              transition: theme.transitions.hoverDefault,
              ...theme.titleLink(theme.textGrayRgbNums)
            }}
            href={titleUrl}
          >
            {title}
          </Link>
        : title
      }
    </h2>
  </div>
)

BlockHeader.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default BlockHeader
